import { render, staticRenderFns } from "./BulkDeliveryOrderHistoryDetail.vue?vue&type=template&id=5062e3ce&scoped=true&"
import script from "./BulkDeliveryOrderHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./BulkDeliveryOrderHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./BulkDeliveryOrderHistoryDetail.vue?vue&type=style&index=0&id=5062e3ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062e3ce",
  null
  
)

export default component.exports